import styled from 'styled-components'
import { themeGet } from 'styled-system'

// TODO: final theme will be implemented in ticket LEARN-9392

export const Wrapper = styled.div.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  padding: 0 ${themeGet('spacing.turquoise20_1_25rem')};
  width: calc(100% - (2 * ${themeGet('spacing.turquoise20_1_25rem')}));
  display: flex;
  flex-direction: column;
  ${themeGet('breakpoints.mobile')} {
    padding: 0 ${themeGet('spacing.blue16_1rem')};
    width: calc(100% - (2 * ${themeGet('spacing.blue16_1rem')}));
  }
`

export const Text = styled.div.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  margin: 0;
  padding: 0;
  color: ${themeGet('colors.primaryCopy')};
  font-family: ${themeGet('fonts.label')};
  font-size: 1rem;
  letter-spacing: 0;
`

export const Background = styled.div.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  margin: 0;
  margin-top: 0.3125rem;
  padding: 0;
  height: 0.9375rem;
  border-radius: 0.5313rem;
  background-color: ${themeGet('colors.progressBar.background')};
  width: 100%;
  position: relative;
`

export const Indicator = styled.div.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  margin: 0;
  height: 0.9375rem;
  border-radius: 0.5313rem;
  background-color: ${({ isOnlyLeader }) =>
    isOnlyLeader
      ? themeGet('colors.progressBar.leaderPrimary')
      : themeGet('colors.progressBar.primary')};
  width: ${({ percentComplete }) => `${percentComplete}%`};
  max-width: 100%;
  position: relative;
`

export const GoalIndicator = styled.div`
  height: 10px;
  width: 2px;
  background: ${themeGet('colors.elemDigital1')};
`

export const GoalIndicatorWrapper = styled.div.attrs(
  ({ goalPercentage, goalValue }) => ({
    left: goalValue ? '100%' : `${goalPercentage}%`,
  }),
)`
  position: absolute;
  left: ${({ left }) => left};
  top: 16px;
`

export const GoalText = styled.p.attrs(({ goalPercentage, goalValue }) => ({
  right: goalValue ? '98%' : goalPercentage > 20 ? '98%' : '44%',
}))`
  text-align: right;
  position: relative;
  right: ${({ right }) => right};
  width: 100px;
  font-size: 0.875rem;
  font-style: italic;
  color: ${themeGet('colors.darkGray')};
`

export const PercentCompleteText = styled.p.attrs(({ percentComplete }) => ({
  right: percentComplete < 10 ? '-32px' : '8px',
  color:
    percentComplete < 10
      ? themeGet('colors.darkGray')
      : themeGet('colors.white'),
}))`
  position: absolute;
  top: -2px;
  right: ${({ right }) => right};
  font-size: 0.875rem;
  font-family: ${themeGet('font.molde.medium')};
  color: ${({ color }) => color};
`
